import Backbone from 'backbone'
import _ from 'lodash'
import EditForm from 'scoreboard/components/edit/edit-form'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'

var CannotEditCopyView = Backbone.View.extend({
	className: 'reports-edit cannot-edit-copy',

	/**
	 * @param {String} options.section
	 * @param {Function} options.headerFn called with (subsection, model, view)
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function () {

		const {section, headerFn} = this.options
		const sectionLabel = _.toLower(i18n.get(metadata[section].singularCode))

		this.header = headerFn('edit', this.model, this)
		this.$el.append(this.header.render().$el)

		// This is a template copy, so we can't change most of the data.
		// The EditForm will handle logic for what buttons to show and whether
		// to allow editing the label or prefix/suffix
		this.editForm = new EditForm({ section, model: this.model })
		this.$el.append(this.editForm.el)
		this.editForm.render()

		// There are three occasions where we'll need to change what's visible
		// inside the .edit-form:
		// 1. We're displaying a folder
		if (this.model.get('type') == 'folder') {
			this.editForm.$el.addClass('is-folder')
			this.$('.display-pane-header').after(`<div class="banner">${i18n.get('template.cannotEditCopyFolder')}</div>`)
		// 2. We're displaying an inherited domain object from an org-level template copy
		} else if (this.model.get('templateId') && this.model.get('organizationIsCopy')) {
			this.editForm.$el.addClass('is-org-template')
			this.$('.display-pane-header').after(`<div class="banner">${i18n.get('template.cannotEditCopyDomainObject', sectionLabel)}</div>`)
		// 3. We're displaying a template report made directly from another template
		} else if (this.model.get('templateId') && !this.model.get('organizationIsCopy')) {
			this.editForm.$el.addClass('is-direct-template')
			this.$('.display-pane-header').after(`<div class="banner">${i18n.get('template.cannotEditCopyDomainObjectPrefixSuffix', sectionLabel)}</div>`)
		}

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this)
		})

		this.formView.start()

		return this
	},

	submit: function () {
		this.model.save({
			label: this.editForm.val(),
			// Jackson struggles to deserialize IdLabelAndOrganization, and it isn't
			// changed on the client anyway, so just omit it
			template: null
		}, {
			success: function(model) {
				this.trigger('save', model)
				Backbone.trigger('edit:domain-object', model)

				this.formView.start({ isNew: false })
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.header, this.editForm, this.formView], 'remove')
	}
})

export default CannotEditCopyView

CannotEditCopyView.__filename__ = 'components/designer/cannot-edit-copy-view.js'
